import { ProcessGeneral } from 'api/endpoints/processes';
import BaseRepo from 'container/BaseRepo';
import { buildBadRequestApiError } from 'container/helpers/errors';
import { ApiResponseAsync } from 'container/models';
import {
  IRevenovaRepo,
  RevenovaConnection,
  RevenovaConnectionTestResponse,
} from 'container/services/revenova/IRevenova';

export class RevenovaRepo extends BaseRepo implements IRevenovaRepo {
  test = (
    processDraft: ProcessGeneral,
    connection: RevenovaConnection
  ): ApiResponseAsync<RevenovaConnectionTestResponse> => {
    const link = processDraft._links?.verifyRevenovaCredentials.href;
    if (!link) {
      return Promise.resolve(
        buildBadRequestApiError(
          new Error('link "verify Revenova credentials" is not available')
        )
      );
    }

    return this.helpers.handlePost(link, connection);
  };
}
